import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { getCMSObject, RecentDrawings, formatDateTBD, TeleScript, NextDrawings } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';
import Layout from '../Components/Layout';

import promotionConfig from '../promotionConfig';

const WinnersPage = ({ user, config, winner, cmsSourceFirebase, actions, match }) => {
    const telescriptRecentDrawings = getCMSObject('data.components.teleScripts.RecentDrawings.jsonBlock');
    const telescriptNextDrawing = getCMSObject('data.components.teleScripts.nextDrawing.jsonBlock');

    const renderCarouselItem = (drawing) => (
        <div className='next-drawing-card mt-2 mb-5'>
            <h3>{drawing.promotion}</h3>
            <div>{drawing.drawing_date}</div>
            <hr className='next-drawing-divider' />

            <div>
                <TeleScript line={telescriptNextDrawing?.promotionText}>Want More Chances to Win? </TeleScript>
            </div>

            <Button className='next-drawing-button' href='/enter'>
                Enter Now
            </Button>
        </div>
    );

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <div className='winners-container'>
                <NextDrawings
                    {...{ user, winner, cmsSourceFirebase, actions }}
                    formatDate={formatDateTBD?.dateWithDayOfTheWeek}
                    telescript={telescriptNextDrawing ?? ''}
                    options={{
                        variant: 'theme-blue',
                        limitOnePerSweepstake: promotionConfig?.nextDrawingsLimitOnePerSweepstake ?? true,
                        maxElement: promotionConfig?.nextDrawingsMaxElement ?? 5,
                        promotionDetailsLink: '/promotion',
                    }}
                    renderCarouselItem={renderCarouselItem}
                />
                <RecentDrawings
                    winner={winner}
                    actions={actions}
                    telescript={telescriptRecentDrawings}
                    WinnerLink={WinnerLinkWrapper}
                    createDetailsLink={(sweepsId) => `/promotion?id=${sweepsId}`}
                    options={{
                        variant: 'theme-blue',
                        hasCollapser: true,
                        promotionNameKey: 'drawing_group',
                        hash: 'recent-drawings',
                        pageSize: 10,
                    }}
                />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(WinnersPage);

/*
import React from 'react';
import { connect } from 'react-redux';
import { CMSContent, hasCMSContent, DisplayContent } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';


const TermsPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (

            <DisplayContent note='Privacy Policy section' isVisible={hasCMSContent('data.legalAndPolicyItems.privacyPolicy.contentHTML')}>
                <div className='enter-container container-fluid'>
                    <div className='row justify-content-center'>
                        <div className='entry-box col-10'>
                            <h2 className='text-center my-4'>
                                <CMSContent
                                    localStorageObject='webContent'
                                    contentPath='data.legalAndPolicyItems.termsOfUse.contentHeaderText'
                                    cmsSourceFirebase={cmsSourceFirebase}
                                />
                            </h2>
                            <div>
                                <CMSContent
                                    localStorageObject='webContent'
                                    contentPath='data.legalAndPolicyItems.termsOfUse.contentHTML'
                                    cmsSourceFirebase={cmsSourceFirebase}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsPage);
*/
